import { SeamHttp } from "@seamapi/http"
import { useSessionState } from "core/hooks/use-session-state"
import { attachToastInterceptorsToClient } from "./toast"
import { attachSeamDevToolsRecorder } from "core/hooks/seam-dev-tools-recorder"

export function getSeamHttpClient<TWorkspaceId extends string | undefined>(
  workspace_id: TWorkspaceId
): TWorkspaceId extends string ? SeamHttp : null {
  if (workspace_id == null) return null as never
  if (globalThis.window == null) return null as never
  const session_token = useSessionState.getState().sessionToken
  if (session_token == null) return null as never

  const endpoint = process.env.NEXT_PUBLIC_API_HOST
  if (endpoint == null) return null as never

  const seam = SeamHttp.fromConsoleSessionToken(session_token, workspace_id, {
    endpoint,
    axiosOptions: {},
    // `@seamapi/http` v2.3.0 introduced a default 30s request timeout where v1
    // had none. Console fetches devices and events in pages of 2000, which can
    // take longer than that on large workspaces, and a timeout there surfaces as
    // a failed page rather than a slow one. Keep an explicit, generous bound
    // instead of inheriting the new default.
    timeout: 120_000,
  })

  attachToastInterceptorsToClient(seam.client)
  attachSeamDevToolsRecorder(seam.client, workspace_id)

  return seam as never
}

export function useSeamHttpClient<TWorkspaceId extends string | undefined>(
  workspace_id: TWorkspaceId
) {
  return getSeamHttpClient<TWorkspaceId>(workspace_id)
}
